import { FaFacebook, FaInstagram } from 'react-icons/fa'
import { Footer as SharedFooter } from '@sifrovacihra/shared-ui'

export const Footer = () => {
    return (
        <SharedFooter
            items={[
                {
                    key: "knihovna",
                    href: "https://www.knihovnatabor.cz/",
                    logo: <img src="https://www.sifrovacihra.cz/sift/logo_knihovna_bez_okraje.png" alt="Logo_knihovna" />,
                },
                {
                    key: "facebook",
                    href: "https://www.facebook.com/knihovnatabor/",
                    icon: <FaFacebook size={30} />,
                },
                {
                    key: "instagram",
                    href: "https://www.instagram.com/knihovna_tabor/",
                    icon: <FaInstagram size={30} />,
                },
            ]}
        />
    )
}
